import React, { Component } from 'react';
import { connect } from "react-redux";
import { compose } from "redux";
import { getCartProducts, getisAuthenticated, getSchool, getUserData, getParentSchools, getHasUniformCatalog } from '../modules/reducers';
import { logoutUser, setSchool, clearCart } from "../modules/actions";
import { FILE_DOWNLOAD_URL } from '../Config';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navbarHeight: 0,
        };
        this.navbarRef = React.createRef();
    }
    
      componentDidMount() {
        this.updateNavbarHeight();
        window.addEventListener("resize", this.updateNavbarHeight);
      }
    
      componentDidUpdate(prevProps) {
        if (prevProps.school !== this.props.school) {
            this.updateNavbarHeight();
        }
      }

      componentWillUnmount() {
        window.removeEventListener("resize", this.updateNavbarHeight);
      }
    
      updateNavbarHeight = () => {
        if (this.navbarRef.current) {
          this.setState({ navbarHeight: this.navbarRef.current.clientHeight });
        }
      };
    // componentDidMount() {
    //     console.log('user', this.props.user)
    // }
    logoutUser = () => {
        this.props.logout();
        window.location.href = 'login';
    }
    render() {
        const schoolPath = `school/${this.props.school.slug || this.props.school.name}`;
        return (
            <header className="site-navbar" role="banner">
                <div className="site-navbar-top" ref={this.navbarRef}>
                    <div className="container">
                        <div className="row align-items-center">

                            {/* Logo and Logout Button for Small Screens */}
                            <div className="col-12 d-flex align-items-center justify-content-between d-md-none mb-2">
                                <div className="site-logo">
                                    <a href={schoolPath} className="js-logo-clone">
                                        <img src={this.props.hasUniformCatalog ? "images/uniform-logo.jpeg" : "images/logo.png"} height={this.props.hasUniformCatalog ? "90px" : "50px"} />
                                    </a>
                                </div>
                                <div className="col-8 col-md-4 order-3 order-md-3 text-right d-md-none ml-auto">
                                    <div className="site-top-icons">
                                        <ul>
                                            {/* <li><a href="login"><span className="icon icon-person" /></a></li> */}
                                            {!this.props.isAuthenticated ? <li><a href="login" className='btn btn-primary ml-2 loginBtn'>Login</a></li> : ''}
                                            {this.props.isAuthenticated && (
                                                <li className="dropdown" style={{ listStyle: 'none', display: 'inline-block' }}>
                                                    <button
                                                        type="button"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                        style={{ background: 'none', border: 'none', padding: '0 6px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '4px', color: '#555', outline: 'none', boxShadow: 'none' }}
                                                    >
                                                        <span className="icon icon-person" style={{ fontSize: '22px' }} />
                                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                                                            <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-right" style={{ minWidth: '180px' }}>
                                                        <h6 className="dropdown-header">Switch School</h6>
                                                        <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#602b71'; e.currentTarget.style.color = 'white'; }}
                                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = ''; e.currentTarget.style.color = ''; }}
                                                            onClick={(e) => { e.preventDefault(); window.location.href = 'selectSchool'; }}
                                                        >
                                                            All Schools
                                                        </a>
                                                        <div className="dropdown-divider" />
                                                        {this.props.parentSchools.map((s, i) => (
                                                            <a
                                                                key={s._id || i}
                                                                className={`dropdown-item${this.props.school && this.props.school._id === s._id ? ' active' : ''}`}
                                                                href="#"
                                                                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#602b71'; e.currentTarget.style.color = 'white'; }}
                                                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = ''; e.currentTarget.style.color = ''; }}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.props.clearCart();
                                                                    this.props.setSchool(s);
                                                                    window.location.href = 'school/' + (s.slug || s.name);
                                                                }}
                                                            >
                                                                {s.name}
                                                            </a>
                                                        ))}
                                                    </div>
                                                </li>
                                            )}
                                            {this.props.isAuthenticated || this.props.school?.name ?
                                                <li>
                                                    <a href="cart" className="site-cart">
                                                        <span className="icon icon-shopping_cart" />
                                                        <span className="count">{this.props.products.length}</span>
                                                    </a>
                                                </li>
                                                : ''}
                                            {this.props.isAuthenticated ?
                                                <li>
                                                    <button className='btn ml-2' onClick={() => this.logoutUser()}>Logout</button>
                                                </li>
                                                : ''}
                                            <li className="d-inline-block d-md-none ml-md-0"><a href="#" className="site-menu-toggle js-menu-toggle"><span className="icon-menu" /></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-6 mb-3 mb-md-0 col-md-4 order-2 order-md-1 text-left d-none d-md-block">
                                <div className="site-logo">
                                    <a href={schoolPath} className="js-logo-clone1">
                                        <img src={this.props.hasUniformCatalog ? "images/uniform-logo.jpeg" : "images/logo.png"} height={this.props.hasUniformCatalog ? '90px' : '65px'} />
                                    </a>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 order-1 order-md-2 site-search-icon text-center">
                                {this.props.isAuthenticated ? <h4 className='text-black'>Welcome {this.props.user.studentName}</h4> : ''}
                                {this.props.school.name && this.props.school?.thb ? <img src={FILE_DOWNLOAD_URL + '/' + this.props.school.thb} height={'65px'} /> : ''}
                                {this.props.school.name ? <h4 className='text-black'>{this.props.school.name}</h4> : ''}
                            </div>
                            <div className="col-6 col-md-4 order-3 order-md-3 text-right ml-auto d-none d-md-block">
                                <div className="site-top-icons">
                                    <ul>
                                        {/* <li><a href="login"><span className="icon icon-person" /></a></li> */}
                                        {!this.props.isAuthenticated ? <li><a href="login" className='btn btn-primary ml-2 loginBtn'>Login</a></li> : ''}
                                        {this.props.isAuthenticated && (
                                            <li className="dropdown" style={{ listStyle: 'none', display: 'inline-block' }}>
                                                <button
                                                    type="button"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    style={{ background: 'none', border: 'none', padding: '0 6px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '4px', color: '#555', outline: 'none', boxShadow: 'none' }}
                                                >
                                                    <span className="icon icon-person" style={{ fontSize: '22px' }} />
                                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                                                        <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-right" style={{ minWidth: '180px' }}>
                                                    <h6 className="dropdown-header">Switch School</h6>
                                                    <a
                                                        className="dropdown-item"
                                                        href="#"
                                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#602b71'; e.currentTarget.style.color = 'white'; }}
                                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = ''; e.currentTarget.style.color = ''; }}
                                                        onClick={(e) => { e.preventDefault(); window.location.href = 'selectSchool'; }}
                                                    >
                                                        All Schools
                                                    </a>
                                                    <div className="dropdown-divider" />
                                                    {this.props.parentSchools.map((s, i) => (
                                                        <a
                                                            key={s._id || i}
                                                            className={`dropdown-item${this.props.school && this.props.school._id === s._id ? ' active' : ''}`}
                                                            href="#"
                                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#602b71'; e.currentTarget.style.color = 'white'; }}
                                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = ''; e.currentTarget.style.color = ''; }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.props.clearCart();
                                                                this.props.setSchool(s);
                                                                window.location.href = 'school/' + (s.slug || s.name);
                                                            }}
                                                        >
                                                            {s.name}
                                                        </a>
                                                    ))}
                                                </div>
                                            </li>
                                        )}
                                        {this.props.isAuthenticated || this.props.school?.name ?
                                            <li>
                                                <a href="cart" className="site-cart">
                                                    <span className="icon icon-shopping_cart" />
                                                    <span className="count">{this.props.products.length}</span>
                                                </a>
                                            </li>
                                            : ''}
                                        {this.props.isAuthenticated ?
                                            <li>
                                                <button className='btn ml-2' onClick={() => this.logoutUser()}>Logout</button>
                                            </li>
                                            : ''}
                                        <li className="d-inline-block d-md-none ml-md-0"><a href="#" className="site-menu-toggle js-menu-toggle"><span className="icon-menu" /></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <nav className={`site-navigation text-right text-md-center`} style={{ marginTop: `${this.props.school.name ? this.state.navbarHeight : 100}px` }} role="navigation">
                    <div className="container">
                        <ul className="site-menu js-clone-nav d-none d-md-block">
                            <li className={this.props.page === 'about' ? 'active bold' : ''}><a href="about">About</a></li>
                            <li className={this.props.page === 'schools' ? 'active bold' : ''}><a href="selectSchool">Schools</a></li>
                            {this.props.isAuthenticated ?
                                <>
                                    <li className={this.props.page === 'myOrders' ? 'active bold' : ''}><a href="myOrders">My Orders</a></li>
                                    <li className={this.props.page === 'myStudents' ? 'active bold' : ''}><a href="myStudents">My Students</a></li>
                                </>
                                : ''}
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: getUserData(state),
        products: getCartProducts(state),
        isAuthenticated: getisAuthenticated(state),
        school: getSchool(state),
        parentSchools: getParentSchools(state),
        hasUniformCatalog: getHasUniformCatalog(state),
    }
}

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(logoutUser()),
    setSchool: (school) => dispatch(setSchool(school)),
    clearCart: () => dispatch(clearCart()),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Header);